import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Navbar from '../components/Navbar';

const PaymentFailed = ({ user, onLogout }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const bookingId = searchParams.get('booking');

  return (
    <div className="min-h-screen bg-gray-50" data-testid="payment-failed-page">
      <Navbar user={user} onLogout={onLogout} />
      
      <div className="flex items-center justify-center min-h-[70vh]">
        <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full mx-4 text-center">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-10 h-10 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </div>
          
          <h1 className="text-2xl font-bold text-gray-800 mb-2">Payment Failed</h1>
          <p className="text-gray-600 mb-6">
            Unfortunately, your payment could not be processed. Please try again or use a different payment method.
          </p>
          
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
            <p className="text-sm text-yellow-800">
              <strong>💡 Tip:</strong> Make sure you have sufficient balance and that your payment details are correct.
            </p>
          </div>
          
          <div className="space-y-3">
            {bookingId && (
              <button
                onClick={() => navigate(`/payment/${bookingId}`)}
                className="w-full bg-gradient-to-r from-orange-500 to-orange-600 text-white py-3 rounded-lg hover:shadow-lg font-semibold"
                data-testid="try-again-btn"
              >
                Try Again
              </button>
            )}
            
            <button
              onClick={() => navigate('/dashboard')}
              className="w-full border border-gray-300 text-gray-700 py-3 rounded-lg hover:bg-gray-50 font-semibold"
              data-testid="go-to-dashboard-btn"
            >
              Back to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;
